module.exports = __webpack_public_path__ + "static/media/settings.dbaca3ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/settings.png
// module id = 1059
// module chunks = 0